import { AppError } from "../errorHandling";
import { HttpError, HttpErrorCode } from "./http-error";

export enum ApiErrorCode {
    ResponseDataExpressedError = "ResponseDataExpressedError",
    OtherError = "OtherError",
}

export interface ApiErrorDescriptor {
  code: string;
  description: string;
}

export interface ApiErrorDetails {
    statusCode: string;
    statusCategory: string;
    errorList: ApiErrorDescriptor[];
    apiStack?: any;
    correlationId?: string;
}

export class ApiError extends AppError {
    private _apiErrorDetails: ApiErrorDetails | undefined;

    constructor(source: string, errorCode: ApiErrorCode, userMessage: string, url: string, method: string, statusCode: number, apiErrorDetails?: ApiErrorDetails,
        stack?: string, innerError?: Error) {

        super(source, errorCode, userMessage, stack, innerError);
        this.details = Object.assign({}, apiErrorDetails);   
    }

    public get apiErrorDetails() {
        return this._apiErrorDetails;
    }

    public isApiError() {
        return true;
    }
}


